// these should not be visible to the user
export default [
  'Type',
  'CategoryPathName',
  'CategoryPathNameId',
  'CategoryPathId',
  'ValidFrom',
  'ValidUntil',
  'ProductGroup',
  'FamilyPage',
  'Documenttype',
  '3D-CAD Modell_B',
  'Inhalt_A',
  'GTIN (EAN-Code)_A',
  'Menge_A',
  'Preis_N',
];
